import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import useDataBean from '../../core/services/dataBean/useDataBean';
import { _DocumentFactory } from '../../core/services/dataBean/EntityCatalog';
import { PrintJson } from '../theme/Component/PrintJson';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectDocumentTemplateFileFormat = ({ idSelector, onChange, label }: Props) => {

    const { lista, setLista, instance } = useDataBean(_DocumentFactory)
    const [id, setID] = useState<number>(0);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = e;
        setID(Number(selectedId));
        if (onChange) {
            onChange(selectedId);
        }
    };

    const getLista = () => {
        instance.getDocumentTemplateFileFormat(null).then(
            (resp: any) => {
                setLista(resp);
                setID(resp[0].DataBeanProperties.Value);
                onChange(resp[0].DataBeanProperties.Value);
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <label>{label ?? "Tipo de Documento"}</label>
            {/* <PrintJson  json={lista} /> */}
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}